var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassIconHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.218 4.3166v1.2266c1.3778 0.43007 2.3817 1.6774 2.3817 3.1671v3.9493c0 1.8443-1.529 3.3396-3.414 3.3396h-6.7705c-1.8859 0-3.4149-1.4953-3.4149-3.3396v-3.9493c0-1.4898 1.0047-2.737 2.3817-3.1671v-1.2266c0.00813-2.3849 1.9834-4.3166 4.4058-4.3166 2.4549 0 4.4302 1.9318 4.4302 4.3166zm-4.4138-2.9257c1.6501 0 2.9914 1.3117 2.9914 2.9254v1.0541h-5.9909v-1.07c0.00813-1.6058 1.3494-2.9096 2.9995-2.9096zm0.7072 10.173c0 0.3895-0.31703 0.6995-0.71534 0.6995-0.39018 0-0.7072-0.31-0.7072-0.6995v-1.7648c0-0.38158 0.31702-0.69162 0.7072-0.69162 0.39831 0 0.71534 0.31004 0.71534 0.69162v1.7648z",
    clipRule: "evenodd",
    fill: "#00649C",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassIconHover);
export default __webpack_public_path__ + "static/media/pass-icon-hover.968af1e3087635fdd48295f4b5e2ded7.svg";
export { ForwardRef as ReactComponent };